<script>
	import OffersSafetyMattersPriorBooking from '../components/OffersSafetyMattersPriorBooking.svelte';
    import CampingStayDetails from "../components/CampingStayDetails.svelte";
    let galleryitems = [
        "Tent-Camp-Bangalore-6in1-3.jpg",
        "Tent-Camp-Bangalore-2in1-4.jpg",
        "Tent3.jpg",
        "Tent4.jpg",
        "Tent2.jpg",
        "Tent1.jpg"
    ]

    let campinghutdetails = [
        {
            "packagename": "Camping Hut Stay Package",
            "type": "2 in 1 Hut",
            "about":"Accommodates two adult.",
            "description": "(03 PM TO 12 PM) Mocktail drink ,Buffet Breakfast, Hi-tea ,BBQ Dinner, Buffet Dinner, Campfire, Party Pool, Mist dance, 10 Coupons/person (Adventure games / Fish spa), use of standard facilities of the resort.",
            "price": "Per Person ₹ 2,650",
            "bookinglink": "http://bookings.mangomist.com/dayoutpacks-tent.php?type=c&p=camp"
        }
    ];
</script>

<div class="image-background">
    <h1 class="header_text_wrapper text-left"><span>CAMPING (TENT)</span><span class="separator"></span></h1>
</div>
<div class="page-pattern">
    <div class="d-flex h-content mobile-fc">
        <div class="half-box d-flex align-items-center">
            <h2>Gallery</h2>
        </div>
        <div class="half-box">
            <div id="carouselForCamHut" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-inner">
                    {#each galleryitems as item, i}
                        <div class="carousel-item {i == 0 ? 'active' : ''}">
                            <img src="/images/{item}" class="d-block w-100" alt="{item}">
                        </div>
                    {/each}
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselForCamHut" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselForCamHut" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    </div>
    <div class="d-flex flex-container gap-10">
        <div class="">
            {#each campinghutdetails as item}
                <CampingStayDetails packagename={item.packagename} type={item.type} about={item.about} description={item.description} price={item.price} bookinglink={item.bookinglink} />
            {/each}
        </div>
    </div>
    <div class="container-fluid">
        <OffersSafetyMattersPriorBooking />
    </div>
</div>
<style>
	.image-background {
        background: url("../images/Clipboard01-2.jpg") no-repeat center;
    }
    
    .page-pattern {
		background: rgba(0, 0, 0, 0) url("../images/gpattern-opacity-1.png") repeat scroll 0 0;
	}

    .h-content {
        background: #0f2453 !important;
    }

    .half-box {
        width: 50%;
    }

    .h-content .half-box {
        width: 50%;
    }

    h2 {
        color: #967a50;
        margin-left: 10px;
    }

        /* Responsive layout - makes a one column-layout instead of two-column layout */
    @media (max-width: 800px) {
        .flex-container {
            flex-direction: column;
        }
    }

    @media only screen and (min-width: 320px) and (max-width: 600px) {
        .half-box {
            width: 100% !important;
        }
    }
  
</style>